import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { NgbModal, NgbModalConfig, NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { Attestation } from "../../../service/global.service";
import { TranslateModule } from '@ngx-translate/core';
import { ModalpartComponent } from 'src/app/components/modalpart/modalpart.component';
import { TranslationService } from 'src/app/service/translation.service';
import { forkJoin } from 'rxjs';
import { ScoreDetailsComponent } from './score-details/score-details.component';
import { CommonsModalPartComponent } from '../../commons-modal-part/commons-modal-part';

@Component({
  selector: 'app-attestation-modal',
  templateUrl: './attestation-modal.component.html',
  styleUrls: ['./attestation-modal.component.scss'],
  standalone: true,
  providers: [NgbModalConfig, NgbModal, TranslationService],
  imports: [
    TranslateModule,
    NgbPopoverModule,
    ModalpartComponent,
    ScoreDetailsComponent,
    CommonsModalPartComponent
  ]
})
export class AttestationModalComponent {

  @Input() attestationCourante?: Attestation;
  @Input() listeprobes?: string[];
  @Output() filtreApp = new EventEmitter<string>();

  scoreMax = 100;
  detailsA = signal(true);
  listDP = signal(false);
  dpdetails = signal(false);
  metadata = signal<Map<any, any> | undefined>(undefined);

  readonly translationService = inject(TranslationService);

  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  open({ content }: { content: any }) {
    this.modalService.open(content, { size: 'xl' });
    forkJoin([
      this.translationService.get('menu-attestations'),
      this.translationService.get('attestations-title-details')
    ]).subscribe(([menuAttestations, titleDetails]) => {
      document.title = `DIP - ${menuAttestations} - ${titleDetails} ${this.attestationCourante?.id}`;
    });
  }

  static decitohexa(id: number | undefined): string {
    if (id !== undefined) {
      if (id < 0) {
        id = 0xFFFFFFFF + id + 1;
      }
      return id.toString(16).toUpperCase();
    }
    return "Unknown ID";
  }

  static formatDetectorName(name: string | undefined): string {
    return name ? name.replaceAll("_", " ") : "Unknown detector";
  }

  getApp(event: string) {
    this.filtreApp.emit(event);
  }

  statutProbe(family: string): string {
    return family ? "probe-ok" : "probe-fatal";
  }

  ldetectorsprobes = signal<Map<any, any> | undefined>(undefined);
  familleCourante = signal<string | undefined>(undefined);

  getAllProbesDetectors(family: string) {
    const res = new Map();
    const map = this.attestationCourante?.probes;
    if (map) {
      for (const [key, value] of Object.entries(map)) {
        if (key.includes(family)) {
          res.set(key, value);
        }
      }
    }
    this.ldetectorsprobes.set(res);
  }

  async backModal() {
    await new Promise(r => setTimeout(r, 200));
    if (!this.detailsA() && this.listDP() && !this.dpdetails()) {
      this.detailsA.set(true);
      this.listDP.set(false);
    }
    if (this.dpdetails()) {
      this.detailsA.set(false);
      this.listDP.set(true);
      this.dpdetails.set(false);
    }
    if (this.metadata() && !this.detailsA()) {
      this.metadata.set(undefined);
      this.detailsA.set(true);
    }
  }

  async resetModal() {
    await new Promise(r => setTimeout(r, 500));
    this.detailsA.set(true);
    this.listDP.set(false);
    this.dpdetails.set(false);
    this.metadata.set(undefined);
    this.resetTitle();
  }

  detailsprobestitle?: string;

  setFamilyselected(noms: string) {
    this.familleCourante.set(noms);
  }

  formatTitlePDProbes() {
    const container = document.getElementById('modal-basic-title2');
    this.translationService.get('attestations-title-details').subscribe(detailsTitle => {
      let output = `${detailsTitle} ${this.detailsprobestitle?.toLowerCase()}`;
      const lang = this.translationService.getCurrentLang();
      if ((lang === "en" || lang === "fr") && !this.dpdetails()) {
        this.translationService.get('attestations-modal-title-lprobedetectors').subscribe(lprobe => {
          output = lang === "en"
            ? `${detailsTitle} <b>${this.familleCourante()}</b>${lprobe}`
            : `${detailsTitle} ${lprobe} <b>${this.familleCourante()}</b>`;
          if (container) container.innerHTML = output;
        });
        return;
      }
      if (container) container.innerHTML = output;
    });
  }

  resetTitle() {
    forkJoin([
      this.translationService.get('menu-attestations'),
      this.translationService.get('list')
    ]).subscribe(([menuAttestations, list]) => {
      document.title = `DIP - ${menuAttestations} - ${list}`;
    });
  }

  setMetadata(event: Map<any, any> | undefined) {
    this.metadata.set(event);
  }
}
